import { Button, alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Add } from "@mui/icons-material";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  primary: {
    width: "100%",
    "&.MuiButton-root": {
      fontSize: 16,
      fontWeight: 600,
      color: "white",
      background: theme.palette.theme.main,
      "&:disabled": {
        background: alpha(theme.palette.theme.main, 0.3),
      },
      "&:hover": {
        background: theme.palette.theme.main,
      },
      height: 45,
      textTransform: "none",
      padding: theme.spacing(2),
    },
  },
  secondary: {
    width: "100%",
    "&.MuiButton-root": {
      fontSize: 16,
      fontWeight: 600,
      color: "black",
      height: 45,
      textTransform: "none",
      padding: theme.spacing(2),
      borderColor: "black",
      "&:hover": {
        borderColor: "black",
      },
    },
  },
}));

export function HeaderButton(props) {
  const classes = useStyles();
  const { children, onClick, type, showIcon, disabled } = props;

  return (
    <Button
      startIcon={showIcon === true && <Add />}
      className={classes[type]}
      variant={type === "secondary" ? "outlined" : "text"}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}

HeaderButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
  showIcon: PropTypes.bool,
  disabled: PropTypes.bool,
};
